import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { TrendingUp, Eye, Users, Target } from "lucide-react";

const SuccessMetrics = () => {
  const anim = useScrollAnimation();

  const metrics = [
    {
      icon: Eye,
      stat: "3M+",
      label: "Views pro Video",
      description: "Maximale Reichweite für unsere Kunden",
      detail: "Einzelne Reels und Kurzvideos haben über 3 Millionen Views erreicht"
    },
    {
      icon: TrendingUp,
      stat: "2M",
      label: "Views in 6 Monaten",
      description: "Wachstum für kleine Unternehmen",
      detail: "Ein lokales Business in der Region erreichte 2 Millionen Views innerhalb eines halben Jahres"
    },
    {
      icon: Users,
      stat: "350%",
      label: "Reichweiten-Steigerung",
      description: "Durchschnittliches Wachstum",
      detail: "Basierend auf Branchen-Benchmarks für professionellen Social Media Content"
    },
    {
      icon: Target,
      stat: "120%",
      label: "Mehr Engagement",
      description: "Höhere Interaktionsrate",
      detail: "Professioneller Content erzielt durchschnittlich 120% mehr Likes, Kommentare und Shares"
    }
  ];

  return (
    <section className="section-padding bg-gradient-to-b from-primary/5 to-background">
      <div
        ref={anim.ref}
        className={`container-custom transition-all duration-1000 ${
          anim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Messbare Erfolge für unsere Kunden
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Von kleinen Businesses bis zu etablierten Unternehmen in Mannheim, Heidelberg, Stuttgart und der gesamten Rhein-Neckar-Region
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="group relative bg-background/50 backdrop-blur-xs border border-primary/20 rounded-2xl p-6 hover:border-primary/40 hover:shadow-xl transition-all"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl group-hover:bg-primary/10 transition-colors" />
              
              <div className="relative z-10">
                <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                  <metric.icon className="w-7 h-7 text-primary" />
                </div>
                
                <div className="text-4xl font-bold text-primary mb-2">
                  {metric.stat}
                </div>
                
                <h3 className="text-lg font-semibold mb-2">
                  {metric.label}
                </h3>
                
                <p className="text-sm text-muted-foreground mb-3">
                  {metric.description}
                </p>
                
                <div className="pt-3 border-t border-primary/20">
                  <p className="text-xs text-muted-foreground">
                    {metric.detail}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 border border-primary/20 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">
            Warum professioneller Content den Unterschied macht
          </h3>
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mt-8">
            <div>
              <div className="text-3xl font-bold text-primary mb-2">87%</div>
              <p className="text-sm text-muted-foreground">höhere Conversion mit Video auf Landing Pages*</p>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary mb-2">5x</div>
              <p className="text-sm text-muted-foreground">mehr Engagement auf Social Media mit professionellem Content*</p>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary mb-2">50x</div>
              <p className="text-sm text-muted-foreground">besseres Ranking für Video-Content in Suchmaschinen*</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-6">
            *Basierend auf allgemeinen Branchenstatistiken und Marketing-Studien
          </p>
        </div>
      </div>
    </section>
  );
};

export default SuccessMetrics;
